module.exports = __webpack_public_path__ + "media/images/h2_bg-15bedd522b5985f3518c3e29def5b5d4.gif";